/**
 * TipoIcono — el ícono del tipo de contenido de una tarea. Reemplaza a TIPO_EMOJI (brand book SOA 10 PRO, «Biblioteca de
 * íconos y elementos» §02): 15 tipos oficiales en 5 familias de color. Tile de 48 px (radio 15, ícono 26) en su tamaño grande.
 * El emoji queda solo para mails de texto plano.
 */
export const FAMILIAS = {
  Video:  { c: "#5B21B6", bg: "#EDE9FE", punto: "#8B5CF6" },
  Diseño: { c: "#155E75", bg: "#CFFAFE", punto: "#22D3EE" },
  Foto:   { c: "#065F46", bg: "#D1FAE5", punto: "#10B981" },
  Social: { c: "#92400E", bg: "#FEF3C7", punto: "#F59E0B" },
  Texto:  { c: "#3B3E46", bg: "#ECEDF1", punto: "#6B6F7A" },
};

/** tipo → [ícono, familia]. Los 15 oficiales y los alias de tipos viejos. */
export const TIPO_ICONO = {
  Reel: ["movie", "Video"], Video: ["videocam", "Video"], UGC: ["smart_display", "Video"], "Live / Streaming": ["live_tv", "Video"],
  Gráfica: ["image", "Diseño"], Carrusel: ["view_carousel", "Diseño"], "Imagen estática": ["wallpaper", "Diseño"], Infografía: ["insert_chart", "Diseño"],
  Fotos: ["photo_camera", "Foto"], Cobertura: ["event", "Foto"],
  Historias: ["amp_stories", "Social"], "Anuncio (Ads)": ["campaign", "Social"], "Meme / Tendencia": ["mood", "Social"],
  Artículo: ["article", "Texto"], Newsletter: ["mail", "Texto"],
  // alias y tipos heredados
  Historia: ["amp_stories", "Social"], "Imagen Estática": ["wallpaper", "Diseño"], Cartelería: ["image", "Diseño"],
  Documento: ["article", "Texto"], Presentación: ["slideshow", "Texto"], "Presentación/Documento": ["slideshow", "Texto"],
};
const POR_DEFECTO = ["article", "Texto"];

export const iconoDeTipo = (tipo) => (TIPO_ICONO[tipo] || POR_DEFECTO)[0];
export const familiaDeTipo = (tipo) => FAMILIAS[(TIPO_ICONO[tipo] || POR_DEFECTO)[1]];

const CAJAS = {
  sm: "h-6 w-6 rounded-lg text-[16px]",
  md: "h-8 w-8 rounded-xl text-[20px]",
  lg: "h-10 w-10 rounded-2xl text-[24px]",
  xl: "h-12 w-12 rounded-[15px] text-[26px]",   // tile oficial de 48 px
};

/** tamano: "sm" (24) | "md" (32) | "lg" (40) | "xl" (48, tile oficial) · sinFondo: solo el ícono, en el color de la familia */
export default function TipoIcono({ tipo, tamano = "md", className = "", sinFondo = false }) {
  const [nombre, fam] = TIPO_ICONO[tipo] || POR_DEFECTO;
  const { c, bg } = FAMILIAS[fam];
  return (
    <span className={`msr inline-grid shrink-0 place-items-center ${sinFondo ? "" : (CAJAS[tamano] || CAJAS.md)} ${className}`}
          style={sinFondo ? { color: c } : { background: bg, color: c }} role="img" aria-label={tipo || "Tarea"}>
      {nombre}
    </span>
  );
}
